import {Item} from "../types";
import * as React from "react";
import {TableCell} from "@variocube/cube-ui";

export function ItemTableCell({item}: {item?: Item}) {
    return (
        <TableCell>
            <div><strong>{item?.name}</strong></div>
            <div>{item?.foreignId || item?.description}</div>
        </TableCell>
    )
}